// extracted by mini-css-extract-plugin
export default {"root":"DataFiltersMenu_root__IDzV0","open-button":"DataFiltersMenu_open-button__zLjL0","close-button":"DataFiltersMenu_close-button__ZgMWD"};